"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M23,1v22H1V1H23 M24,0H0v24h24V0L24,0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7,8.2c0.3,1.4,2.1,0.7,2.2-0.1C16.1,6.9,15,6.4,13,6.5 c-3.4,0.1-7.8,2.7-8.3,7.1c-0.3,2.4,2,4.1,3.8,4c1.5-0.1,1.8-0.1,2.7-0.5c0.5-0.2,1.8-0.8,1.8-1.5c0-0.1-0.1-0.3-0.3-0.3 c-0.3,0-0.7,0.5-1,0.7c-0.9,0.5-2,0.8-3.1,0.6c-1.9-0.4-2.3-2.6-1.5-4.8c0.6-1.6,2.3-4.9,6.4-4.6C14.2,7.3,13.6,7.9,13.7,8.2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9,12.7c0.1,0,0.1,0.1,0.1,0.3c0,0.5,0.2,0.4,0.5,0.4c0.5,0,0.8-0.3,0.8-0.9 c0-0.5-0.2-0.9-0.6-0.9c-1.1,0-1.8,1.8-2.4,2.8l0.2-0.6c0.1-0.5,0.3-1,0.3-1.5c0-0.5-0.2-0.7-0.5-0.7c-0.6,0-1.1,0.5-1.6,1 c-0.1,0.2-0.5,0.7-0.6,0.9c0,0.1,0,0.2,0.1,0.2c0.2,0,0.7-1.1,1.1-1.1c0.1,0,0.1,0.1,0.1,0.2c0,0.3-0.2,0.9-0.3,1.2l-0.9,2.9 l-0.1,0.3c0,0.1-0.1,0.3-0.1,0.3c0,0.2,0.2,0.2,0.3,0.2h0.3c0.2,0,0.6,0,0.7-0.1c0.1-0.1,0.2-0.3,0.2-0.4 C16.2,14.8,17.5,12.7,17.9,12.7"
  }));
};

exports["default"] = _default;